(function() {
  if (window.ShopifyCartMoq) return;

  const STORAGE_KEY = 'shopify_cart_click_collect';

  function safeStorageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeStorageSet(key, val) {
    try {
      sessionStorage.setItem(key, val);
    } catch (e) {}
  }

  window.ShopifyCartMoq = {
    isClickCollectActive: function() {
      if (document.body.classList.contains('cart-click-collect-active')) {
        return true;
      }
      return safeStorageGet(STORAGE_KEY) === 'true';
    },

    isActive: function() {
      // Return true if MOQ is bypassed via Click & Collect OR no invalid MOQ warning exists
      if (this.isClickCollectActive()) return true;
      const invalidWarning = document.querySelector('[data-moq-warning][data-moq-invalid="true"]');
      return !invalidWarning;
    },

    syncBlockInstance: function(blockElement) {
      const isServerSet = blockElement.getAttribute('data-is-cc-saved') === 'true';
      const sessionVal = safeStorageGet(STORAGE_KEY);
      const isSessionSet = sessionVal === 'true';
      const isSessionUnset = sessionVal === 'false';

      let active = false;
      if (isSessionSet) {
        active = true;
      } else if (!isSessionUnset && isServerSet) {
        active = true;
      }

      this.applyState(active, false);
    },

    syncStateFromDom: function() {
      const moqBlocks = document.querySelectorAll('[data-moq-wrapper]');
      if (moqBlocks.length === 0) {
        // No MOQ warning block on page - ensure normal checkout state
        document.body.classList.remove('cart-moq-invalid');
        this.updateCheckoutButtons(true);
        return;
      }

      // Check if server or session marked it as Click & Collect
      let hasServerSaved = false;
      moqBlocks.forEach(function(el) {
        if (el.getAttribute('data-is-cc-saved') === 'true') {
          hasServerSaved = true;
        }
      });

      const sessionVal = safeStorageGet(STORAGE_KEY);
      let active = false;
      if (sessionVal === 'true') {
        active = true;
      } else if (sessionVal !== 'false' && hasServerSaved) {
        active = true;
      }

      this.applyState(active, false);
    },

    applyState: function(active, syncServer) {
      if (active) {
        document.body.classList.add('cart-click-collect-active');
        document.body.classList.remove('cart-moq-invalid');
        safeStorageSet(STORAGE_KEY, 'true');
      } else {
        document.body.classList.remove('cart-click-collect-active');
        safeStorageSet(STORAGE_KEY, 'false');

        // Check if there are active MOQ blocks on the page
        const moqBlocks = document.querySelectorAll('[data-moq-wrapper]');
        if (moqBlocks.length > 0) {
          document.body.classList.add('cart-moq-invalid');
        } else {
          document.body.classList.remove('cart-moq-invalid');
        }
      }

      // Sync all checkboxes on page
      document.querySelectorAll('.cart-moq-click-collect__input').forEach(function(input) {
        input.checked = active;
      });

      // Sync wrappers & warnings
      document.querySelectorAll('[data-moq-wrapper]').forEach(function(wrapper) {
        if (active) {
          wrapper.classList.add('cart-moq--bypassed');
          wrapper.setAttribute('data-moq-invalid', 'false');
        } else {
          wrapper.classList.remove('cart-moq--bypassed');
          wrapper.setAttribute('data-moq-invalid', 'true');
        }
      });

      document.querySelectorAll('[data-moq-warning]').forEach(function(warn) {
        warn.setAttribute('data-moq-invalid', active ? 'false' : 'true');
        const delMsg = warn.querySelector('.cart-moq-msg-delivery');
        const colMsg = warn.querySelector('.cart-moq-msg-collect');
        if (delMsg) delMsg.style.display = active ? 'none' : 'block';
        if (colMsg) colMsg.style.display = active ? 'flex' : 'none';
      });

      // Update checkout buttons
      this.updateCheckoutButtons(active);

      // Update Shopify Cart attributes via AJAX
      if (syncServer) {
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Order Type': active ? 'Click & Collect' : '',
              'Click & Collect': active ? 'Yes' : ''
            }
          })
        }).catch(function(err) {
          console.warn('[MOQ Click & Collect] Could not update cart attributes:', err);
        });
      }
    },

    updateCheckoutButtons: function(enabled) {
      const checkoutBtns = document.querySelectorAll(
        '#checkout, .cart__checkout-button, button[name="checkout"], #CartDrawer-Checkout, #cart-notification-form button'
      );

      checkoutBtns.forEach(function(btn) {
        if (enabled) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
          btn.style.pointerEvents = 'auto';
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
          btn.style.filter = 'none';
        } else {
          // Only disable if an invalid MOQ warning exists
          const hasInvalidMoq = document.querySelector('[data-moq-warning][data-moq-invalid="true"]');
          if (hasInvalidMoq) {
            btn.setAttribute('aria-disabled', 'true');
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.55';
            btn.style.cursor = 'not-allowed';
            btn.style.filter = 'grayscale(40%)';
          } else {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            btn.style.pointerEvents = 'auto';
            btn.style.opacity = '1';
            btn.style.cursor = 'pointer';
            btn.style.filter = 'none';
          }
        }
      });
    }
  };

  // Define custom element for automatic lifecycle trigger on any DOM insertion
  if (!customElements.get('cart-moq-block')) {
    class CartMoqBlock extends HTMLElement {
      connectedCallback() {
        window.ShopifyCartMoq.syncBlockInstance(this);
      }
    }
    customElements.define('cart-moq-block', CartMoqBlock);
  }

  // Delegated event listener for checkbox toggle (catches any checkbox added via innerHTML)
  function handleCheckboxToggle(e) {
    const input = e.target.closest('.cart-moq-click-collect__input');
    if (input) {
      window.ShopifyCartMoq.applyState(input.checked, true);
    }
  }
  document.addEventListener('change', handleCheckboxToggle);
  document.addEventListener('input', handleCheckboxToggle);

  // Intercept checkout clicks or form submissions if MOQ is invalid
  function blockMoqCheckout(e) {
    if (window.ShopifyCartMoq.isActive()) {
      return true;
    }

    const warning = document.querySelector('[data-moq-warning][data-moq-invalid="true"]');
    if (!warning) {
      return true;
    }

    const btn = e.target.closest(
      'button[name="checkout"], input[name="checkout"], .cart__checkout-button, #cart-notification-form button'
    );
    const form = e.target.closest('form');
    const isCheckoutFormSubmit =
      e.type === 'submit' &&
      form &&
      (form.id === 'cart-notification-form' ||
        form.id === 'cart' ||
        form.id === 'CartDrawer-Form' ||
        (form.action && form.action.includes('/checkout')));

    if (btn || isCheckoutFormSubmit) {
      e.preventDefault();
      e.stopPropagation();
      warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
      warning.classList.remove('cart-moq-shake');
      void warning.offsetWidth; // trigger reflow
      warning.classList.add('cart-moq-shake');
      return false;
    }
  }

  document.addEventListener('click', blockMoqCheckout, true);
  document.addEventListener('submit', blockMoqCheckout, true);

  // Subscribe to Dawn pubsub cart events if present
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      setTimeout(function() {
        window.ShopifyCartMoq.syncStateFromDom();
      }, 50);
    });
  }

  // Initial run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.ShopifyCartMoq.syncStateFromDom();
    });
  } else {
    window.ShopifyCartMoq.syncStateFromDom();
  }
})();
